'use strict';

import $ from 'jquery';
import { ajaxDelete } from '@/js/modules/ajax';
import confirmDialog from '@/js/modules/confirm_dialog';
import { onPageLoad } from '@/js/modules/page_load';

function scrollToLocationHash() {
  const locationHash = window.location.hash;
  if ($(locationHash).length) {
    if (locationHash && locationHash.match(/shoppable-comment/)) {
      const threadEl = locationHash.split('&')[0];
      const $el = $(threadEl);
      if ($el.length) {
        $('html, body').animate(
          {
            scrollTop: $el.offset().top - 100,
          },
          400
        );
        $el.click();
      } else {
        $('html, body').animate(
          {
            scrollTop: $('#discuss-target').offset().top,
          },
          400
        );
      }
    } else if (locationHash && locationHash.match(/comment-panel/)) {
      $('html, body').animate(
        {
          scrollTop: $(locationHash).offset().top - 500,
        },
        400
      );
      $(locationHash).click();
    }
  }
}

export const closelastOpenedComment = ($comment) => {
  if (!$comment.length) {
    return;
  }

  const $body = $comment.find('.comment__body');
  $comment.removeClass('comment--opened');
  $comment.find('.file-uploader-field').val('');
  $comment.find('.file-preview-link').remove();
  $comment.find('.comment-editor, .comment__form-controls').hide();
  $body.show();
  $comment.find('.comment__controls').show();
};

onPageLoad(() => {
  $(function () {
    $(document).on('click', '.shoppable-comment-button', (e) => {
      const boardId = $('meta[name=board-id]').attr('content');
      if ($(e.target).hasClass('shoppable-comment-button--active')) {
        $('.shoppable-comment__close').click();
        return false;
      }
      $('.shoppable-comment__close.close-modal').click();
      $(e.target).addClass('shoppable-comment-button--active');
      const shoppableData = $(e.target).parents('.shoppable').data();
      // NOTE: use "async: false" to force virtual keyboard show up in iOS
      $.ajax({
        url: `/shoppables/${boardId}/board_${shoppableData.kind}/${shoppableData.boardShoppableId}/comments`,
        type: 'get',
        async: false,
        success: (shoppableCommentData) => {
          $('.shoppable-comment').remove();
          const $ShoppableComment = $(shoppableCommentData).addClass(
            'shoppable-comment--shoppable shoppable-comment--shoppable-transition'
          );
          const $button = $(
            `button[data-commentable-type="${shoppableData.kind}"][data-commentable-id="${shoppableData.boardShoppableId}"]`
          );
          $button
            .closest('.shoppable__comment-button-container')
            .addClass('shoppable__comment-button-container--active');
          $button
            .before($ShoppableComment)
            .prev('.shoppable-comment')
            .show(0, () => {
              $ShoppableComment.removeClass('shoppable-comment--shoppable-transition');
              setTimeout(() => {
                $ShoppableComment.css('overflow', 'hidden');
              }, 1);

              setTimeout(() => {
                $ShoppableComment.css('overflow', 'visible');
              }, 200);
            });
        },
      });
    });

    $(document).on('click', '.shoppable-comment--shoppable .shoppable-comment__cancel-link', () => {
      $('.shoppable-comment__close').click();
      return false;
    });

    // close shppable comments container
    $(document).on('click', '.shoppable-comment__close', function () {
      const $shoppableCommentsContainer = $(this).parents('.shoppable-comment');

      $($shoppableCommentsContainer).css({
        transition: '.2s',
        opacity: 0,
      });

      $('.shoppable__comment-button-container').removeClass(
        'shoppable__comment-button-container--active'
      );
      setTimeout(() => {
        $($shoppableCommentsContainer).remove();
      }, 200);

      $('.shoppable-comment-button').removeClass('shoppable-comment-button--active');
      return false;
    });

    // hide notes when opeming modal windows
    $(document).on(
      $.modal.OPEN,
      '.modal--shoppable-comment-uploader, .modal--comment-uploader',
      () => {
        $('.shoppable-comments-container').hide();
      }
    );

    // close shoppable comment by pressing escape
    $(document).keyup(function (e) {
      if (e.keyCode === 27) {
        $('.shoppable-comment__close').click();
      }
    });

    function updateCommentButtonBadge() {
      const shoppableData = $(
        '.shoppable-comment--shoppable .shoppable-comment__comments-container'
      )
        .parents('.shoppable-comment')
        .data();
      const commentsCount = $(
        '.shoppable-comment--shoppable .shoppable-comment__comments-container'
      ).find('.comment').length;

      if (shoppableData !== undefined) {
        const $commentButtonSelector = $(
          `button[data-commentable-type="${shoppableData.commentableType}"][data-commentable-id="${shoppableData.commentableId}"]`
        );
        if ($commentButtonSelector.data() !== undefined) {
          $commentButtonSelector.attr('data-badge-content', commentsCount);
        }
      }
    }

    // create new shoppable comment
    // TODO: rename form
    $(document).on('submit', '.shoppable-comment__form', (e) => {
      e.preventDefault();
      const $form = $(e.target);
      const isPrivateNote = $form.find('.shoppable-comment__kind').val() === 'private_note';

      const $message = $('.shoppable-comment__body', $form);
      const comment = $message.val().replaceAll('<p><br></p>', '');
      $message.val(comment);

      if (isPrivateNote) {
        const $tiptapEditor = $form.find('.tiptap');
        const mentionedUserIds = $.map($tiptapEditor.find('[data-type="mention"]'), (el) => {
          return $(el).data('id');
        });

        $('#comment_user_ids', $form).val(mentionedUserIds);
      }

      const formData = new FormData(e.target);
      const $submit = $('button', $form);
      const $fileUploadField = $form.find('.file-uploader-field');
      const imageElementName = $fileUploadField.attr('name');
      const imageFiles = $fileUploadField.data().files;

      formData.delete(imageElementName);

      for (const idx in imageFiles) {
        formData.append(imageElementName, imageFiles[idx], imageFiles[idx].name);
      }

      if ($message.val().length) {
        $submit.addClass('button-loading').prop('disabled', true);
        $.ajax({
          url: $form.attr('action'),
          type: 'POST',
          data: formData,
          processData: false,
          contentType: false,
        }).done((data) => {
          $form
            .closest('.shoppable-comment')
            .find('.shoppable-comment__comments-container')
            .append(data)
            .scrollTop(999999);

          updateCommentButtonBadge();

          $('.shoppable-comment__form').find('.file-uploader-field').val('');
          $('.shoppable-comment__form').find('.file-preview-link').remove();
          $fileUploadField.data('files', []);
          $submit.removeClass('button-loading').prop('disabled', false);
        });
      }

      return false;
    });

    // update shoppable comment
    $(document).on('submit', '.edit-comment-form', (e) => {
      e.preventDefault();
      const $form = $(e.target);
      const $comment = $form.closest('.comment');

      const $message = $('.comment__body-field', $form);
      if ($message.length) {
        const commentText = $message.val().replaceAll('<p><br></p>', '');
        $message.val(commentText);
      }

      const isPrivateNote = $comment.hasClass('comment--private-note');
      if (isPrivateNote) {
        const $tiptapEditor = $form.find('.tiptap');
        const mentionedUserIds = $.map($tiptapEditor.find('[data-type="mention"]'), (el) => {
          return $(el).data('id');
        });

        $('#comment_user_ids', $form).val(mentionedUserIds);
      }
      const formData = new FormData(e.target);
      const $submit = $('button', $form);

      if (!$message.length || $message.val().length) {
        $submit.addClass('button-loading').prop('disabled', true);
        $.ajax({
          url: $form.attr('action'),
          type: 'PUT',
          data: formData,
          processData: false,
          contentType: false,
        }).done((data) => {
          $comment.replaceWith($(data));

          $form.find('.file-uploader-field').val('');
          $form.find('.file-preview-link').remove();
          $submit.removeClass('button-loading').prop('disabled', false).hide();
        });
      }

      return false;
    });

    // cancel adding a new coment
    $(document).on('click', '.shoppable-comment__cancel-link', function () {
      $('.shoppable-comment__form--active').removeClass('shoppable-comment__form--active');
      $('.shoppable-comment__form').find('textarea').val('');
      $('.shoppable-comment__form').find('.file-uploader-field').val('');
      $('.shoppable-comment__form').find('.file-preview-link').remove();

      return false;
    });

    // delete shoppable comment
    $(document).on('click', '.comment__delete-link', async function (e) {
      e.preventDefault();

      if (!(await confirmDialog('Delete this comment?', { button: 'Delete' }))) {
        return;
      }

      const $comment = $(this).closest('.comment');
      const id = $comment.data().id;

      ajaxDelete(`/comments/${id}`);
      $comment.slideUp('normal', () => {
        $comment.remove();
        updateCommentButtonBadge();
      });
    });

    // edit shoppable comment
    $(document).on('click', '.comment__edit-link', function (e) {
      const $comment = $(this).closest('.comment');

      // closing last comment that is in edit state
      closelastOpenedComment($comment.siblings('.comment--opened'));

      // remove focus from create shoppable comment form
      if ($comment.parent().hasClass('shoppable-comment__comments-container')) {
        $('.shoppable-comment-with-kind').hide();
        $('.shoppable-comment-without-kind').show();
      }

      $comment.addClass('comment--opened');

      // hide the exposed comment to replace it with the editor
      const $body = $comment.find('.comment__body');
      $body.hide();

      // show the comment editor and the related controls
      $comment.find('.comment-editor, .comment__form-controls').show();
      $comment.find('.comment-editor .tiptap').focus();

      $comment.find('.comment__controls').hide();

      // scroll comment into view
      if ($('.shoppable-comment__comments-container').length) {
        const currentshoppableCommentPos = $(this)
          .closest('.shoppable-comment__comments-container')
          .scrollTop();
        const currentCommentPos =
          $(this).closest('.comment').offset().top -
          $('.shoppable-comment__comments-container').offset().top;
        $('.shoppable-comment__comments-container').scrollTop(
          currentshoppableCommentPos + currentCommentPos
        );
      }

      return false;
    });

    // cancel editing shoppable comment
    $(document).on('click', '.comment__cancel-link', (e) => {
      const $comment = $(e.target).closest('.comment');
      const $body = $comment.find('.comment__body');

      $comment.removeClass('comment--opened');
      $comment.find('.file-uploader-field').val('');
      $comment.find('.file-preview-link').remove();
      $comment.find('.comment__form-controls').hide();
      $comment.find('.comment-editor').hide();
      $body.show();
      $comment.find('.comment__controls').show();

      return false;
    });

    scrollToLocationHash();
  });
});
